// apiFetch.js
// Wrapper around fetch() that prepends the Vercel API base URL when running
// inside a Capacitor native app. In the browser the app is already served from
// the same origin, so relative /api paths work fine — no prefix needed.
//
// Usage: import apiFetch from './apiFetch';
//        const res = await apiFetch('/api/google/events', { headers: { ... } });

import { Capacitor } from '@capacitor/core';

const API_BASE = Capacitor.isNativePlatform()
  ? import.meta.env.VITE_API_BASE   // e.g. https://orbit-prototype-phi.vercel.app
  : '';

export default function apiFetch(path, options) {
  return fetch(`${API_BASE}${path}`, options);
}
